import { render, staticRenderFns } from "./select_chapter.vue?vue&type=template&id=565c75d0&scoped=true&"
import script from "./select_chapter.vue?vue&type=script&lang=js&"
export * from "./select_chapter.vue?vue&type=script&lang=js&"
import style0 from "./select_chapter.vue?vue&type=style&index=0&id=565c75d0&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565c75d0",
  null
  
)

export default component.exports